import { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';
import React from 'react';
import { validationContext } from 'src/shared/validation';

interface ValidationMessageProps {
    validationKey: string;
}

export const ValidationMessageStyled = styled.span`
    padding: 0;
    margin: 0;
    color: red;
    font-size: 11px;
    white-space: pre-wrap;
`;

const ValidationMessage: FunctionComponent<ValidationMessageProps> = (props) => {
    const _validationContext = useContext(validationContext);
    const validation = _validationContext.validations?.find((v) => v.validationKey == props.validationKey);
    const hasError = !!(validation && validation.message);
    return <ValidationMessageStyled data-has-error={hasError || undefined}>{hasError ? validation.message : ' '}</ValidationMessageStyled>;
};

export default ValidationMessage;
